import VideoDataStore from "models/video_data_store"
import { loadTemplate } from "utils/load_template"
import { CustomControlBase } from "wistia/player_controls/custom_control_base"

class CustomSeekControl extends CustomControlBase {
  constructor (video, options) {
    super(video, options)
    this.moveTo = options.moveTo || ((t) => { return t })
  }

  mountButton(buttonRoot) {
    this.buttonRoot = buttonRoot
    this.updateButtonText()
    this.setButtonLabel(this.buttonLabel)
  }

  onClickButton (event) {
    this.video.time(this.moveTo(this.video))
  }

  updateButtonText () {
    this.buttonRoot.innerHTML = this.buttonText
  }
}

export class BackwardControl extends CustomSeekControl {
  constructor(video) {
    super(video, {
      moveTo: (video) => {
        return Math.max(0, video.time() - 10)
      },
      buttonText: loadTemplate("video-player-backward-control-template"),
      buttonLabel: "Rewind 10 sec."
    })
  }
}
BackwardControl.sortValue = 2
BackwardControl.handle = 'backwardControl'

export class ForwardControl extends CustomSeekControl {
  constructor(video) {
    super(video, {
      moveTo: (video) => {
        return Math.min(video.time() + 10, this.getDataStore().getLimitForward() ? this.getDataStore().getMaxWatchedSecond() : video.duration())
      },
      buttonText: loadTemplate("video-player-forward-control-template"),
      buttonLabel: "Skip 10 sec."
    })
  }
}
ForwardControl.sortValue = 3
ForwardControl.handle = 'forwardControl'
